<template>
  <div :class="{'d-none': !ativo}">
    <ItemLista
      v-for="(categoria, index) in categorias"
      :key="index"
      :height="50"
      class="d-flex align-center"
    >
      <div class="col-6 pa-0 d-flex align-center">
        <div style="width: 57px" />

<!--        <div class="cursor-pointer" @click="selecionar(categoria)">-->
<!--          <v-icon-->
<!--            v-if="categoriasSelecionados.includes(categoria)"-->
<!--            color="#142454"-->
<!--            v-text="'mdi-checkbox-marked'"-->
<!--          />-->
<!--          <v-icon v-else color="#142454" v-text="'mdi-checkbox-blank-outline'" />-->
<!--        </div>-->

        <p v-text="categoria.descricao_categoria" :title="categoria.descricao_categoria" class="informacao pl-1 pr-3 text-truncate" />
      </div>

      <div class="col-6 pa-0">
        <p class="pa-0 informacao">
          <span class="descricao">Quantidade:&nbsp;</span>
          <span class="valor" v-text="`${Helpers.formatarValor(categoria.sugerido)} ${categoria.unidade_compra}`" />
        </p>

        <p class="pa-0 mt-1 informacao">
          <span class="descricao">Preço unitário:&nbsp;</span>
          <span class="valor" v-text="`${Helpers.formatarValorMonetario(categoria.preco_custo)}`" />
        </p>
      </div>
    </ItemLista>
  </div>
</template>

<script>
import ItemLista from "./ItemLista";
import {buscarCategoriasFornecedorPedido} from "../../../../../../api/compraPorDepartamentos/Fornecedor";

export default {
  name: "ProdutosPedidoFornecedor",
  components: {ItemLista},
  props: {
    departamento: {
      type: Object,
      required: true
    },
    ativo: Boolean,
    selecionarDepartamentoCallback: Function,
  },
  data: () => ({
    categorias: [],
    categoriasSelecionados: [],
  }),
  watch: {
    ativo() {
      if (!this.ativo) return;

      this.buscarCategoriasFornecedor();
    },
    categoriasSelecionados(categorias) {
      this.selecionarDepartamentoCallback({...this.departamento, categorias});
    }
  },
  methods: {
    buscarCategoriasFornecedor() {
      if (this.categorias.length > 0) return;

      const {id_pedido_compra, id_fornecedor} = this.departamento;

      this.$store.dispatch('loading/addRequisicao',
        buscarCategoriasFornecedorPedido(id_pedido_compra, id_fornecedor).then(this.carregarDadosTabela));
    },
    carregarDadosTabela(categorias) {
      this.categorias = categorias.map(this.formatarItemProduto)
    },
    formatarItemProduto(item, index) {
      item.index = index;
      return item
    },
    selecionar(item) {
      if (this.categoriasSelecionados.includes(item)) {
        this.categoriasSelecionados = this.categoriasSelecionados.filter(cat => cat !== item);
        return;
      }

      this.categoriasSelecionados.push(item);
    }
  }
}
</script>

<style scoped>
</style>
